<template>
  <b-tab
    title="Product Purchases"
    title-item-class="payment-portal__tab"
    lazy
  >
    <div v-if="!groupedPurchases.length && !isLoading" class="text-center py-4 text-muted">
      No product purchases yet.
    </div>

    <b-overlay
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <b-card
        v-for="group in groupedPurchases"
        :key="group.id"
        class="purchase-group-card mb-4"
        no-body
      >
        <template #header>
          <div class="d-flex align-items-center justify-content-between flex-wrap header-content">
            <h3 class="d-flex align-items-center mb-0 program-title">
              {{ group.program_name }}
              <b-badge
                class="ml-2 text-secondary payment-portal__light-badge"
                pill
              >
                {{ group.application_user_name }}
              </b-badge>
            </h3>
          </div>
        </template>

        <b-list-group flush>
          <b-list-group-item
            v-for="product in group.products"
            :key="product.id"
            class="product-item py-3"
          >
            <div class="d-flex align-items-start">
              <div v-if="product.product_image" class="product-item__image-wrapper mr-3">
                <img :src="product.product_image" :alt="product.product_name" class="product-item__image" />
              </div>

              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-baseline mb-1">
                  <span class="product-item__name">
                    {{ product.product_name }}
                    <span v-if="(!product.selected_options || !product.selected_options.length) && product.quantity > 1" class="text-muted">&times;{{ product.quantity }}</span>
                  </span>
                  <span class="product-item__amount">${{ Number(product.amount).toFixed(2) }}</span>
                </div>

                <div class="product-item__details text-muted">
                  <span v-if="product.category_name" class="mr-2">
                    <b-badge variant="light">{{ product.category_name }}</b-badge>
                  </span>
                  <span v-if="product.selected_options && product.selected_options.length" class="mr-3">
                    <strong>Options:</strong> {{ formatSelectedOptions(product.selected_options) }}
                  </span>
                </div>

                <div class="mt-2">
                  <b-badge :variant="statusVariant(product.status)">
                    {{ product.status }}
                  </b-badge>
                  <div
                    v-if="product.status && product.status.toLowerCase() === 'failed' && product.failure_reason"
                    class="text-danger mt-1"
                    style="font-size: 12px;"
                  >
                    {{ product.failure_reason }}
                  </div>
                </div>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-overlay>
  </b-tab>
</template>

<script>
import { BTab, BOverlay, BBadge, BCard, BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'ProductPurchasesTab',
  components: { BTab, BOverlay, BBadge, BCard, BListGroup, BListGroupItem },
  computed: {
    isLoading() {
      return this.$store.getters['productCatalog/getIsLoading']
    },
    purchases() {
      return this.$store.getters['productCatalog/getMyPurchases'] || []
    },
    // Группировка данных по программе/заявке
    groupedPurchases() {
      const groups = {}

      this.purchases.forEach(purchase => {
        // Используем application_id, если его нет — делаем составной ключ
        const key = purchase.application_id || `${purchase.program_name}_${purchase.application_user_name}`

        if (!groups[key]) {
          groups[key] = {
            id: key,
            program_name: purchase.program_name,
            application_user_name: purchase.application_user_name,
            products: []
          }
        }

        groups[key].products.push(purchase)
      })

      return Object.values(groups)
    }
  },
  created() {
    this.$store.dispatch('productCatalog/fetchMyPurchases')
  },
  methods: {
    statusVariant(status) {
      if (!status) return 'primary'
      return {
        paid: 'success',
        approved: 'success',
        refunded: 'purple',
        failed: 'danger',
        rejected: 'danger',
        pending: 'warning',
        'pending approval': 'warning',
      }[status.toLowerCase()] || 'primary'
    },
    formatSelectedOptions(options) {
      return options
        .map(o => {
          const qty = Number(o?.quantity) || 1
          return qty > 1 ? `${o.label} (x${qty})` : o.label
        })
        .join(', ')
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-group-card {
  border: 1px solid #eceff9;
  border-radius: 8px;
  overflow: hidden;
  //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 4px rgba($secondary, 0.02);

  .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #eceff9;
    padding: 12px 20px;
  }
}

.program-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
}

.product-item {
  border-bottom: 1px solid #f1f3f9;

  &:last-child {
    border-bottom: none;
  }

  &__name {
    font-weight: 600;
    font-size: 15px;
    color: #333;
  }

  &__amount {
    font-weight: 700;
    color: #28a745;
    font-size: 15px;
  }

  &__details {
    font-size: 13px;
    margin-top: 4px;
  }

  &__image-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #f8f9fa;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
</style>